import React, { useState, useRef } from "react";
import { checkChildrenAndSetFocus } from "../common/interactiveCommon";

const KS10NameSalutation = (props) => {
  const { setSalutation, setNameTitleOtherData, nameTitleOther, clearOther } = props;
  const otherDivRef = useRef(null);
  const [selectedTitle, setSelectedTitle] = useState("");

  const handleTitleChange = (event) => {
    console.log("Selected title:", event.target.value);
    const title = event.target.value;
    setSelectedTitle(title);
    setSalutation(title);
    if (event.target.value !== "Other") {
      clearOther();
    }
  };

  const onTextChange = (e) => {
    checkChildrenAndSetFocus(otherDivRef.current.children, e.target.name.replace("nameTitleOther", ""));
    setNameTitleOtherData({ name: e.target.name, value: e.target.value });
  };

  return (
    <div className="row">
      <div className="mb-3 section-number-box col-sm-12 col-md-12 col-lg-12">
        <div className="mb-3 number">2.</div>
        <div className="details">
          <div className="form-group form-inline">
            <div className="section-label">
              <label>Your name</label>
            </div>
            <div className="section-form-group">
              <div className="section-form-group-inline pr-3">
                {["Mr", "Mrs", "Miss", "Ms", "Other"].map((title) => (
                  <div key={title} className="form-check form-check-inline mb-1 mr-2">
                    <input
                      type="radio"
                      id={title.toLowerCase()}
                      name="title"
                      value={title}
                      checked={selectedTitle === title}
                      onChange={handleTitleChange}
                      style={{ transform: "scale(1.5)" }}
                    />
                    <label htmlFor={title.toLowerCase()} className="form-check-label mb-0">{title}</label>
                  </div>
                ))}
              </div>

              <div className="section-form-group-inline" ref={otherDivRef}>
                {[...Array(6).keys()].map(i => (
                    <input
                    key={`nameTitleOther${i + 1}`}
                    maxLength="1"
                    type="text"
                    id={`nameTitleOther${i + 1}`}
                    name={`nameTitleOther${i + 1}`}
                    className="form-control text-center"
                    value={nameTitleOther[i]}
                    onChange={onTextChange}
                    disabled={selectedTitle !== "Other"}
                  />
                ))}
               
              </div>
              <br />
              <small className="d-flex pb-3">Put a dash to indicate your title</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KS10NameSalutation;
